"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BarRenderable", {
  enumerable: true,
  get: function get() {
    return _ColumnRenderable.ColumnRenderable;
  }
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ColumnRenderable = require("./ColumnRenderable");

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 *
 * @component
 *
 * Component used to render bar charts. This component is just an alias for `Column`
 * @name Bar
 *
 * @example
 * <Bar
 *     column={(props) => <rect {...props.columnProps} fill='blue'/>}
 * />
 */
var Bar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Bar, _React$Component);

  function Bar() {
    (0, _classCallCheck2.default)(this, Bar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Bar).apply(this, arguments));
  }

  (0, _createClass2.default)(Bar, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_ColumnRenderable.ColumnRenderable, this.props);
    }
  }]);
  return Bar;
}(_react.default.Component);

exports.default = Bar;
(0, _defineProperty2.default)(Bar, "chartType", 'canvas');